import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

// Create axios instance
export const api = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('qoldo_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Analytics beacon helper
// Accepts either a single event object or an array of events
// Normalizes field names and flattens meta for backend compatibility
export const sendAnalyticsBeacon = async (eventData) => {
  try {
    // Normalize to array
    const eventsArray = Array.isArray(eventData) ? eventData : [eventData];
    
    // Transform each event to match backend schema
    const normalizedEvents = eventsArray.map(e => {
      // Extract block_id from meta if present there
      const meta = e.meta || {};
      const blockId = e.block_id || meta.block_id || null;
      
      // Remove block_id from meta to avoid duplication
      const { block_id: _, ...cleanMeta } = meta;
      
      return {
        course_id: e.course_id,
        visitor_id: e.visitor_id || null,
        share_link_id: e.share_link_id || null,
        event: e.event_type || e.event, // Support both field names
        block_id: blockId,
        t: e.t || null,
        meta: cleanMeta
      };
    });
    
    await api.post('/analytics/beacon', { events: normalizedEvents });
  } catch (error) {
    console.error('Analytics beacon failed:', error);
  }
};